import { useEffect, useRef, useState } from 'react';
import { ADS_CONFIG, currentConsent, loadAdSdk, openAdPreferences, type AdController } from '../ads/sdk';

/** One host, one SDK controller; StrictMode/unmount tears down observers and requests. */
export function AdRail(): JSX.Element | null {
  const host = useRef<HTMLElement>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const element = host.current;
    if (!ADS_CONFIG.enabled || !element) return;
    let disposed = false;
    let controller: AdController | undefined;
    void loadAdSdk().then((sdk) => {
      if (disposed) return;
      // Add the marker after loading to avoid the SDK's auto-mount racing React.
      element.dataset.adApp = ADS_CONFIG.appId;
      element.dataset.adManager = ADS_CONFIG.managerUrl;
      controller = sdk.mount({ ...ADS_CONFIG, element, consent: currentConsent() });
    }).catch(() => { if (!disposed) setFailed(true); });
    return () => { disposed = true; controller?.destroy(); delete element.dataset.adApp; };
  }, []);
  if (!ADS_CONFIG.enabled) return null;
  return <aside ref={host} className="shared-ad-rail cc-ad-rail" aria-label="Sponsored advertisements">
    {failed && <div className="ad-rail-fallback">
      <div><span>SPONSORED</span><button type="button" onClick={openAdPreferences}>Ad choices</button></div>
      <p>Keep building.</p><small>The advertising service is unavailable. Your modelling tools still work.</small>
      <a href="/privacy.html" target="_blank" rel="noopener noreferrer">Privacy & local data</a>
    </div>}
  </aside>;
}
